<template>
    <div class="centerWidth">
        <div class="gaokao-nav">
            <span @click="goMyCenter">个人中心 ></span>
            <span @click="goBack">专业定位测评 ></span>
            <span>开始测试</span>
        </div>
        <location-testa
            v-show="tabId===1"
            :list.sync="list1"
            @next="handleNext"
        ></location-testa>
        <location-testb
            v-show="tabId===2"
            :list.sync="list2"
            @next="handleNext"
            @prev="handlePrev"
        ></location-testb>
        <location-testc
            v-show="tabId===3"
            :list.sync="list3"
            :isSub.sync="isSub"
            @prev="handlePrev"
            @save="handleSave"
        ></location-testc>
		
		<!-- 5.30 -->
		<div class="ptpopupTc flexCenter" v-show="isJiaIng">
			<div class="ptpotxt">
				<div class="ptadiva" id="myChartYuan"></div>
				<p>请稍等,正在为您生成报告...</p>
			</div>
		</div>
    </div>
</template>

<script>
import locationTesta from './locationTestA.vue';
import locationTestb from './locationTestB.vue';
import locationTestc from './locationTestC.vue';
export default {
    components: {
        locationTesta,
        locationTestb,
        locationTestc
    },
    data() {
        return {
			ratioTime:null,
			isJiaIng: false,
            tabId: 1,
            list1: [],
            list2: [],
            list3: [],
            isSub: false
        };
    },
    watch: {
        tabId() {
            document.querySelector('body').scrollTo(0, 0);
            window.scrollTo(0, 0);
        }
    },
	beforeDestroy() {
		if (this.ratioTime) {
			clearTimeout(this.ratioTime);
			this.ratioTime = null;
		}
	},
	mounted() {
		this.drawLineB(0);
	},
    created() {
        this.getQuestion();
    },
    methods: {
		drawLineB(nub) {
			var that = this;
			console.log('nub', nub);
			const myChart = this.$echarts.init(document.getElementById('myChartYuan'));
			myChart.setOption({
				color: ['#feb9a7', '#3171ff00'],
				tooltip: {
					trigger: 'item',
					show: false
				},
				graphic: {
					type: 'text',
					left: 'center',
					top: 'center',
					style: {
						text: nub + '%',
						textAlign: 'center',
						fill: '#7ac8fd',
						fontSize: 24
					}
				},
				legend: {
					top: '0%',
					left: 'center'
				},
				series: [{
					type: 'pie',
					radius: ['55%', '65%'],
					avoidLabelOverlap: false,
					hoverAnimation: false,
					label: {
						show: false,
						position: 'center'
					},
					emphasis: {
						label: {
							show: true,
							fontSize: '40',
							fontWeight: 'bold'
						}
					},
					labelLine: {
						show: true
					},
					data: [{
						value: nub,
						name: ''
					}, {
						value: (100 - nub),
						name: ''
					}]
				}]
			});
			if (nub > 0 && nub < 100) {
				that.ratioTime = setTimeout(() => {
					var dd = nub;
					if (dd === 99) {
						dd = 99;
					} else if (dd > 80) {
						dd = dd + 1;
					} else if (dd > 60) {
						dd = dd + 5;
					} else {
						dd = dd + 10;
					}
					that.drawLineB(dd);
				}, 1000);
			} else {
				if (that.ratioTime) {
					clearTimeout(that.ratioTime);
					that.ratioTime = null;
				}
			}
		},
        // 个人中心
        goMyCenter() {
            this.$router.push('/myIndex');
        },
        // 我的报告
        goReport() {
            this.$router.push('/report');
        },
        // 返回上一级
        goBack() {
            this.$router.go(-1);
        },
        // 下一步
        handleNext() {
            if (this.tabId < 3) {
                this.tabId += 1;
            }
        },
        // 上一步
        handlePrev() {
            if (this.tabId > 1) {
                this.tabId -= 1;
            }
        },
        // 提交
        handleSave() {
            const nameArr = ['兴趣分析', '性格分析', '能力分析'];
            const errArr = [];
            for (let i = 1; i <= 3; i++) {
                const key = `list${i}`;
                const list = this[key];
                const emptyList = list.filter(a => !a.Content && !a.Option && a.OptionList.length === 0);
                if (emptyList.length > 0) {
                    this[key] = list.map(a => {
                        a.notEmpty = !emptyList.some(b => b.Id === a.Id);
                        return a;
                    });
                    errArr.push(nameArr[i - 1]);
                }
            }
            if (errArr.length > 0) {
                this.$util.showError(`${errArr.join(',')}中有未完成的题目，请完成后提交`);
                return;
            }
            const model = {
                EvaluationId: Number(this.$route.query.id),
                Key: this.$route.query.key
            };
            model.Question = [...this.list1, ...this.list2, ...this.list3].map(a => {
                const obj = {
                    QuestionId: a.Id,
                    Type: a.Type,
                    Content: a.Content,
                    Option: a.Option
                };
                if (a.Type === 2) {
                    obj.Option = a.OptionList.join(',');
                }
                if (a.Type === 3 && a.AnswerCount > 1) {
                    a.Content = a.Id === 7 ? `${a.ContentList[0][1]},${a.ContentList[2]}` : a.ContentList.join(',');
                }
                return obj;
            });
			// const loading = this.$loading({
			// 	lock: true
			// });
			this.isJiaIng = true;
			this.drawLineB(10);
            this.$api.saveEvaluation(model).then(res => {
                this.isSub = true;
				this.drawLineB(100);
				setTimeout(() => {
					this.isJiaIng = false;
					setTimeout(() => {
						this.drawLineB(0);
						this.goReport();
						// loading.close();
					}, 300);
				}, 500);
            });
        },
        // 获取题目
        getQuestion() {
            this.$api.getEvaluationQuestion(this.$route.query).then(res => {
                const questionList = res.data.map(a => {
                    a.Title = a.Title.replaceAll('##', '');
                    a.Content = '';
                    a.Option = '';
                    a.OptionList = [];
                    a.ContentList = [];
                    if (a.Type === 3 && a.AnswerCount > 1) {
                        for (let i = 0; i < a.AnswerCount; i++) {
                            a.ContentList.push('');
                        }
                    }
                    a.notEmpty = true;
                    return a;
                });
                this.splitQuestionList(questionList);
            });
        },
        // 分割题目列表
        splitQuestionList(questionList) {
            this.list1 = questionList.filter(a => a.Category === '专业测评第一步--兴趣分析');
            this.list2 = questionList.filter(a => a.Category === '专业测评第二步--性格分析');
            this.list3 = questionList.filter(a => a.Category === '专业测评第三步--能力分析');
        }
    }
};
</script>

<style scoped>
</style>
